'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jbone = require('jbone');

var _jbone2 = _interopRequireDefault(_jbone);

var _view = require('../../core/view');

var _view2 = _interopRequireDefault(_view);

var _fullScreen = require('./full-screen.scss');

var _fullScreen2 = _interopRequireDefault(_fullScreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = {
  enterFullScreen: 'Full screen',
  exitFullScreen: 'Exit Full screen'
};

var FullScreenView = function (_View) {
  _inherits(FullScreenView, _View);

  function FullScreenView(config) {
    _classCallCheck(this, FullScreenView);

    var _this = _possibleConstructorReturn(this, (FullScreenView.__proto__ || Object.getPrototypeOf(FullScreenView)).call(this, config));

    var callbacks = config.callbacks;


    _this._callbacks = callbacks;
    _this.$node = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['full-screen-control'],
      'data-hook': 'full-screen-control',
      'data-tooltip-pos': 'up'
    });

    _this.$toggleFullScreenControl = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['full-screen-toggle'] + ' ' + _this.styleNames.icon,
      'data-hook': 'full-screen-button'
    });

    _this.$node.append(_this.$toggleFullScreenControl);

    _this.setState({ isInFullScreen: false });
    _this._bindEvents();
    return _this;
  }

  _createClass(FullScreenView, [{
    key: '_bindEvents',
    value: function _bindEvents() {
      this.$toggleFullScreenControl[0].addEventListener('click', this._callbacks.onToggleFullScreenButtonClick);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this.$toggleFullScreenControl[0].removeEventListener('click', this._callbacks.onToggleFullScreenButtonClick);
    }
  }, {
    key: 'setState',
    value: function setState(_ref) {
      var isInFullScreen = _ref.isInFullScreen;

      this.$toggleFullScreenControl.toggleClass(this.styleNames['in-full-screen'], isInFullScreen);
      this.$node.attr('data-tooltip', isInFullScreen ? this.translations.exitFullScreen : this.translations.enterFullScreen);
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.$node.toggleClass(this.styleNames.hidden, true);
    }
  }, {
    key: 'show',
    value: function show() {
      this.$node.toggleClass(this.styleNames.hidden, false);
    }
  }, {
    key: 'getNode',
    value: function getNode() {
      return this.$node[0];
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();
      this.$node.remove();

      delete this.$toggleFullScreenControl;
      delete this.$node;
    }
  }]);

  return FullScreenView;
}(_view2.default);

FullScreenView.extendStyleNames(_fullScreen2.default);
FullScreenView.extendTranslations(translations);

exports.default = FullScreenView;
//# sourceMappingURL=full-screen.view.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/ui/controls/full-screen/full-screen.view.js
// module id = 1697
// module chunks = 1 2 3